import { render, staticRenderFns } from "./RentalIncome.vue?vue&type=template&id=b89e6e58"
import script from "./RentalIncome.vue?vue&type=script&lang=js"
export * from "./RentalIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports